import { useSearchParams } from 'react-router-dom';

export const useTableQueryTmpSettingsOption = (): boolean => {
  const [searchParams] = useSearchParams();

  return searchParams?.get('tmp') === '1';
};
